import { useEffect } from 'react';
import { Footer } from './Footer'
import Header from './Header'


const Layout = ({ children }) => {
    useEffect(() => {
        window.scrollTo(0, 0);
  }, []);

    return (
        <div className="layout">

            <Header />
            {children}
            <Footer />

        </div>
    )
}

export default Layout